import { render } from "./TeacherAvailabilityDisplay.vue?vue&type=template&id=56c19484&scoped=true"
import script from "./TeacherAvailabilityDisplay.vue?vue&type=script&lang=js"
export * from "./TeacherAvailabilityDisplay.vue?vue&type=script&lang=js"

import "./TeacherAvailabilityDisplay.vue?vue&type=style&index=0&id=56c19484&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c19484"]])

export default __exports__